/** Parse a `YYYY-MM-DD` calendar date as *local* midnight — the inverse of
 *  `localDateStr` (`@tripcart/shared`). `new Date("2026-08-31")` parses as UTC midnight, which
 *  renders as the previous day for viewers west of UTC; constructing from the
 *  numeric parts pins it to the local civil date. Non-date-only strings (full
 *  ISO instants) fall back to native parsing. */
export function parseLocalDate(value: string): Date {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  return match
    ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]))
    : new Date(value);
}
